// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"127":"2862a06e6eb58f46","185":"4f11e68ce934789a","931":"2862a06e6eb58f46"}[chunkId] + ".css";
};